import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../util/axios";
import CMTModal from "../../components/CMTModal";
import WebhookTable from "../../components/webhookmanagement/WebhookTable";
import { trackPromise } from "react-promise-tracker";
import Timezone from "../../components/common/Timezone";
import Back from "../../components/common/Back";

class WebhookDetails extends Component {
  state = {
    cobrandId: this.props.match ? this.props.match.params.cobrandId : 0,
    cobrand: this.props.match
      ? this.getCobrandDetails(this.props.match.params.cobrandId)
      : JSON.parse(localStorage.getItem("userData")).cobrands[0],
    webhook: [],
    jsonPayload: {},
    showJsonView: false
  };

  componentDidMount() {
    const params = {};
    params.webhookId = this.props.match.params.webhookId;
    trackPromise(
      axios
        .get("/api/webhooks", {
          params: params,
          headers: {
            Authorization: JSON.parse(localStorage.getItem("userData")).token,
            "Cobrand-Id": this.state.cobrand.id
          }
        })
        .then(res => {
          var webhook = [];
          webhook.push(res.data.webhook[0]);
          this.setState({ webhook });
          const jsonPayload = { ...res.data.webhook[0].payload };
          this.setState({ jsonPayload });
        })
        .catch(err => {
          console.log(err);
        })
    );
  }

  getCobrandDetails(cobrandId) {
    var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands;
    var index = cobrands.findIndex(function(cobrand, i) {
      return cobrand.id.toString() === cobrandId;
    });
    return index > -1 ? cobrands[index] : cobrands[0];
  }

  resetJsonView = () => {
    this.setState({ showJsonView: false });
  };

  handleViewPayload = () => {
    this.setState({ showJsonView: true });
  };

  render() {
    return (
      <div className="container main">
        <div className="mt-4">
          <Back uri={"/webhooks/" + this.state.cobrandId} />
        </div>
        <div className="heading mt-2 ">Webhook Details</div>
        <div className="sub-heading">
          <span className="label">Webhook Id: </span>
          {this.props.match.params.webhookId}
        </div>
        <div className="row text-right mb-2 show">
          <div className="col-10" style={{ marginTop: 25 }}></div>
          <div className="col-2" style={{ marginTop: 25 }}>
            <button
              type="button"
              className="btn btn-primary"
              style={{ float: "right" }}
              onClick={this.handleViewPayload}
            >
              View Payload
            </button>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-9">
            <div className="section-header mb-2">Payload Information</div>
          </div>
          <div className="col-3">
            <Timezone label="* Times are displayed in" />
          </div>
        </div>

        {this.state.webhook.length > 0 && (
          <WebhookTable data={this.state.webhook} />
        )}

        {this.state.showJsonView && (
          <CMTModal
            data={this.state.jsonPayload}
            resetJsonView={this.resetJsonView}
            webhookId={this.props.match.params.webhookId}
          />
        )}
      </div>
    );
  }
}

export default WebhookDetails;
